module.exports = __webpack_public_path__ + "img/logo-color.b9b27cab.svg";